<div class="form-group-custom">
  <label for="inputCruiseShip" class="input-group-zeus__label">Nave</label>
  <div
    class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent"
    id="cruiseShip-select"
  >
    <ng-select
      [items]="
        (cruisePrefetch$ | async)?.ships
          | formatPrefetch : 'ships'
          | async
          | ngSelectSortBy : 'Name'
          | costaOnTop: 'Name'
      "
      [loading]="!(cruisePrefetch$ | async)"
      [searchable]="(isMobile$ | async) ? false : true"
      [dropdownPosition]="
        (isMobile$ | async) && (isWidget$ | async) ? 'top' : 'auto'
      "
      placeholder="Seleziona Nave"
      bindLabel="Name"
      bindValue="Id"
      
      (change)="selectShip($event)"
      id="inputCruiseShip"
      class="form-control-custom"
      [(ngModel)]="selectedShipInner"
    >
    </ng-select>
    <div
      class="input-group-custom__prepend input-group-custom__prepend--transparent"
    >
      <span
        class="input-group-custom__icon input-group-custom__icon--transparent"
        id="basic-addon3"
        ><i class="icon-cruise"></i
      ></span>
    </div>
  </div>
</div>
